import { render, staticRenderFns } from "./WithoutResults.vue?vue&type=template&id=589e94a6&scoped=true"
import script from "./WithoutResults.vue?vue&type=script&lang=js"
export * from "./WithoutResults.vue?vue&type=script&lang=js"
import style0 from "./WithoutResults.vue?vue&type=style&index=0&id=589e94a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589e94a6",
  null
  
)

export default component.exports